import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const s = {
  page:     { minHeight: '100vh', background: '#F7F6F2', padding: '52px 20px 80px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  siteBar:  { width: '100%', maxWidth: 580, display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 36 },
  logo:     { fontSize: 13, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: '#6B6560' },
  backLink: { fontSize: 13, color: '#A8A29D', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 5 },
  card:     { width: '100%', maxWidth: 580, background: '#fff', border: '1px solid #E8E5DF', borderRadius: 16, padding: '40px 44px', boxShadow: '0 1px 3px rgba(0,0,0,.05), 0 4px 20px rgba(0,0,0,.04)' },
  eyebrow:  { fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: '#73207C', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 7 },
  dot:      { width: 6, height: 6, borderRadius: '50%', background: '#73207C', flexShrink: 0, display: 'inline-block' },
  h1:       { fontFamily: 'Georgia, serif', fontSize: 26, fontWeight: 'normal', lineHeight: 1.25, color: '#1A1815', marginBottom: 10 },
  meta:     { fontSize: 12.5, color: '#A8A29D' },
  divider:  { height: 1, background: '#E8E5DF', margin: '28px 0', border: 'none' },
  secLabel: { fontSize: 10.5, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: '#73207C', marginBottom: 10 },
  body:     { fontSize: 14.5, color: '#6B6560', lineHeight: 1.72 },
  strong:   { color: '#1A1815', fontWeight: 600 },
};

function Section({ n, title, children }) {
  return (
    <div style={{ marginBottom: 0 }}>
      <div style={s.secLabel}>{n} · {title}</div>
      {children}
    </div>
  );
}

function Ul({ items }) {
  return (
    <ul style={{ paddingLeft: 18, marginTop: 8, fontSize: 14, color: '#6B6560', lineHeight: 1.78 }}>
      {items.map((it, i) => <li key={i} style={{ marginBottom: 3 }} dangerouslySetInnerHTML={{ __html: it }} />)}
    </ul>
  );
}

export default function PoliticaPrivacidade() {
  return (
    <div style={s.page}>

      {/* barra superior */}
      <div style={s.siteBar}>
        <span style={s.logo}>VideoOferta</span>
        <Link to="/entrar" style={s.backLink}>← Voltar</Link>
      </div>

      <motion.div
        style={s.card}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
      >
        {/* cabeçalho */}
        <div style={{ marginBottom: 28 }}>
          <div style={s.eyebrow}><span style={s.dot} /> Documento oficial</div>
          <h1 style={s.h1}>Política de Privacidade</h1>
          <p style={s.meta}>Última atualização: 14 de julho de 2026 &nbsp;·&nbsp; Versão 1.0</p>
        </div>

        {/* callout verde */}
        <div style={{ background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: 10, padding: '18px 20px', marginBottom: 30 }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: '#16A34A', marginBottom: 10 }}>
            ✦ &nbsp;O que você precisa saber primeiro
          </div>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: 13.5, color: '#1A1815', lineHeight: 1.75 }}>
            {[
              ['Seus dados são usados', 'apenas para fazer o app funcionar'],
              ['Não vendemos nem repassamos', 'seus dados a terceiros'],
              ['Você pode solicitar a exclusão', 'de tudo a qualquer momento'],
            ].map(([bold, rest], i) => (
              <li key={i} style={{ display: 'flex', gap: 9, alignItems: 'baseline', marginBottom: i < 2 ? 4 : 0 }}>
                <span style={{ color: '#16A34A', flexShrink: 0 }}>✓</span>
                <span><strong style={s.strong}>{bold}</strong> {rest}</span>
              </li>
            ))}
          </ul>
        </div>

        <hr style={s.divider} />

        {/* 1 */}
        <Section n="1" title="Quem somos">
          <p style={s.body}>
            A <strong style={s.strong}>VideoOferta</strong> é uma plataforma web brasileira para criação de vídeos
            promocionais de produtos, operada no Brasil. Esta política descreve como tratamos os dados pessoais
            coletados durante o uso da plataforma, em conformidade com a{' '}
            <strong style={s.strong}>Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)</strong>.
          </p>
        </Section>

        <hr style={s.divider} />

        {/* 2 */}
        <Section n="2" title="Dados que coletamos">
          <p style={s.body}>Coletamos apenas o necessário para que a plataforma funcione:</p>
          <Ul items={[
            '<strong style="color:#1A1815;font-weight:600">Cadastro:</strong> nome, e-mail, telefone e senha (armazenada com hash seguro — nunca em texto aberto)',
            '<strong style="color:#1A1815;font-weight:600">Conteúdo criado:</strong> vídeos, produtos, logotipos, imagens e áudios que você envia ou gera na plataforma',
            '<strong style="color:#1A1815;font-weight:600">Pagamentos:</strong> valor e plano adquirido. Dados de cartão são processados pelo Mercado Pago — não armazenamos números de cartão',
            '<strong style="color:#1A1815;font-weight:600">Dados técnicos:</strong> endereço IP e informações básicas do dispositivo, usados exclusivamente para segurança e diagnóstico',
          ]} />
        </Section>

        <hr style={s.divider} />

        {/* 3 */}
        <Section n="3" title="Como usamos seus dados">
          <p style={s.body}>Utilizamos seus dados exclusivamente para:</p>
          <Ul items={[
            'Criar e manter sua conta ativa',
            'Renderizar e armazenar os vídeos que você produz',
            'Processar pagamentos e controlar seu saldo de créditos',
            'Enviar e-mails relacionados à sua conta (confirmações, alertas de segurança)',
            'Identificar e resolver falhas técnicas na plataforma',
          ]} />
        </Section>

        <hr style={s.divider} />

        {/* 4 */}
        <Section n="4" title="O que não fazemos com seus dados">
          <p style={s.body}>Deixamos claro: seus dados existem para fazer o app funcionar para você, e só isso.</p>
          <div style={{ background: '#FFF8F0', border: '1px solid #FDDCB5', borderRadius: 10, padding: '18px 20px', marginTop: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.09em', textTransform: 'uppercase', color: '#C2410C', marginBottom: 12 }}>
              Compromissos que assumimos
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                'Não vendemos seus dados a anunciantes, empresas de marketing ou qualquer terceiro',
                'Não compartilhamos suas informações com parceiros para fins comerciais ou publicitários',
                'Não criamos perfis de comportamento para direcionar propagandas',
                'Não enviamos e-mails de marketing sem o seu consentimento expresso',
                'Não acessamos o conteúdo dos seus vídeos para qualquer finalidade além do funcionamento técnico',
              ].map((item, i) => (
                <li key={i} style={{ display: 'flex', gap: 11, alignItems: 'baseline', fontSize: 13.5, color: '#1A1815', lineHeight: 1.65, marginBottom: i < 4 ? 8 : 0 }}>
                  <span style={{ color: '#C2410C', fontSize: 12, fontWeight: 700, flexShrink: 0 }}>✕</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Section>

        <hr style={s.divider} />

        {/* 5 */}
        <Section n="5" title="Parceiros técnicos">
          <p style={s.body}>
            Para que o app funcione, alguns dados passam por serviços externos. Compartilhamos{' '}
            <strong style={s.strong}>apenas o mínimo necessário</strong> para cada função — nenhum desses parceiros
            recebe seus dados para uso próprio.
          </p>
          <div style={{ overflowX: 'auto', marginTop: 14 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5 }}>
              <thead>
                <tr>
                  {['Parceiro', 'Finalidade', 'Dados envolvidos'].map(h => (
                    <th key={h} style={{ textAlign: 'left', padding: '8px 12px', fontSize: 11, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#A8A29D', borderBottom: '1px solid #E8E5DF' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  ['Mercado Pago', 'Processamento de pagamentos', 'Nome, e-mail, valor da compra'],
                  ['Google Cloud', 'Armazenamento de arquivos', 'Imagens, áudios e vídeos enviados'],
                  ['ElevenLabs', 'Geração de narração (TTS)', 'Texto dos produtos para síntese de voz'],
                ].map(([nome, fn, dados], i, arr) => (
                  <tr key={nome}>
                    <td style={{ padding: '10px 12px', borderBottom: i < arr.length - 1 ? '1px solid #E8E5DF' : 'none', fontWeight: 600, color: '#1A1815', verticalAlign: 'top' }}>{nome}</td>
                    <td style={{ padding: '10px 12px', borderBottom: i < arr.length - 1 ? '1px solid #E8E5DF' : 'none', color: '#6B6560', verticalAlign: 'top' }}>{fn}</td>
                    <td style={{ padding: '10px 12px', borderBottom: i < arr.length - 1 ? '1px solid #E8E5DF' : 'none', color: '#6B6560', verticalAlign: 'top' }}>{dados}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Section>

        <hr style={s.divider} />

        {/* 6 */}
        <Section n="6" title="Segurança dos dados">
          <p style={s.body}>Adotamos medidas técnicas para proteger suas informações:</p>
          <Ul items={[
            'Toda comunicação utiliza protocolo <strong style="color:#1A1815;font-weight:600">HTTPS</strong>',
            'Senhas armazenadas com <strong style="color:#1A1815;font-weight:600">hash criptográfico</strong>, nunca em texto aberto',
            'Acesso interno restrito à equipe técnica responsável pela operação',
          ]} />
          <p style={{ ...s.body, marginTop: 12 }}>
            Em caso de incidente de segurança que afete seus dados, notificaremos você e a ANPD conforme exige a LGPD.
          </p>
        </Section>

        <hr style={s.divider} />

        {/* 7 */}
        <Section n="7" title="Seus direitos (LGPD)">
          <p style={s.body}>Como titular dos seus dados, você tem os seguintes direitos garantidos por lei:</p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 14 }}>
            {[
              ['Acesso', 'Consultar quais dados temos sobre você'],
              ['Correção', 'Corrigir dados incompletos ou desatualizados'],
              ['Exclusão', 'Solicitar a remoção permanente de todos os seus dados'],
              ['Portabilidade', 'Receber seus dados em formato estruturado'],
              ['Revogação', 'Retirar consentimento a qualquer momento'],
              ['Informação', 'Saber com quem seus dados foram compartilhados'],
            ].map(([label, desc]) => (
              <div key={label} style={{ background: '#F9F0FA', border: '1px solid #E0C9E5', borderRadius: 8, padding: '12px 14px' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#73207C', marginBottom: 3 }}>{label}</div>
                <div style={{ fontSize: 12.5, color: '#6B6560', lineHeight: 1.5 }}>{desc}</div>
              </div>
            ))}
          </div>
          <p style={{ ...s.body, marginTop: 16 }}>
            Para exercer esses direitos, acesse a{' '}
            <Link to="/solicitar-exclusao" style={{ color: '#73207C', textDecoration: 'underline', textUnderlineOffset: 2 }}>
              página de solicitação de exclusão de dados
            </Link>{' '}
            ou envie um e-mail para privacidade@videooferta.com.
          </p>
        </Section>

        <hr style={s.divider} />

        {/* 8 */}
        <Section n="8" title="Cookies">
          <p style={s.body}>
            Utilizamos apenas <strong style={s.strong}>cookies de sessão essenciais</strong> para manter você
            autenticado enquanto usa a plataforma. Não utilizamos cookies de rastreamento, cookies de terceiros
            para publicidade, nem qualquer tecnologia de monitoramento comportamental.
          </p>
        </Section>

        <hr style={s.divider} />

        {/* 9 */}
        <Section n="9" title="Atualizações e contato">
          <p style={s.body}>
            Esta política pode ser atualizada para refletir mudanças na plataforma ou na legislação.
            Caso haja alterações relevantes, você será notificado por e-mail com antecedência razoável.
          </p>
          <p style={{ ...s.body, marginTop: 10 }}>Para dúvidas ou para exercer seus direitos:</p>
          <Ul items={[
            '<strong style="color:#1A1815;font-weight:600">E-mail:</strong> privacidade@videooferta.com',
            '<strong style="color:#1A1815;font-weight:600">Assunto sugerido:</strong> "LGPD — [seu pedido]"',
          ]} />
        </Section>

      </motion.div>

      {/* rodapé */}
      <p style={{ marginTop: 28, textAlign: 'center', fontSize: 12, color: '#A8A29D', lineHeight: 2 }}>
        VideoOferta &nbsp;·&nbsp;
        <Link to="/solicitar-exclusao" style={{ color: '#A8A29D' }}>Solicitar exclusão de dados</Link>
        &nbsp;·&nbsp;
        <a href="mailto:privacidade@videooferta.com" style={{ color: '#A8A29D' }}>privacidade@videooferta.com</a>
      </p>
    </div>
  );
}
